import Heading from '@atoms/Heading';
import HeadingSize from '@atoms/Heading/sizes';

const NotFound = () => (
  <section>
    <Heading size={HeadingSize.H1}>404 Page</Heading>
  </section>
);

export default NotFound;
